import React from 'react';

export function PreviewBadge() {
  const visible =
    typeof window !== 'undefined' &&
    new URL(window.location.href).searchParams.has('tourPreviewToken');
  if (!visible) return null;

  const exit = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('tourPreviewToken');
    window.location.replace(url.toString());
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 12,
        right: 12,
        zIndex: 9999,
        padding: '6px 10px',
        borderRadius: 12,
        background: 'rgba(254, 243, 199, 0.9)',
        border: '1px solid #FCD34D',
        fontSize: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
      }}
      role="status"
      aria-live="polite"
    >
      <span style={{ marginRight: 8, fontWeight: 600 }}>Tour Preview</span>
      <button
        onClick={exit}
        style={{
          textDecoration: 'underline',
          background: 'transparent',
          border: 0,
          cursor: 'pointer',
        }}
      >
        Exit
      </button>
    </div>
  );
}
